/**
 * @returns True if current environment is server-side (next-js server) or false if client-side (browser).
 */
export function isRunningInServerEnv(): boolean {
  return typeof window === "undefined";
}
